import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
  getCompanyRewards,
  getCompanyRewardsDocuments,
  clearCompanyRewardsDocuments
} from '../../redux/actions';
import {isEmpty} from "lodash";

import {
  BodyTableV1,
  // Circle,
  DocumentsContainer,
  ImageTag,
  Layout,
  RewardTablesContainer,
  // Tick,
  TickMark,MainImage
} from "./newCompanyDetailsStyles";
import {ImageUrl} from "../../utils/constants";
import ReactPDF from "../../components/ReactPDF";
import { withTranslation } from 'react-i18next';
import { commaSeperator, convertMonthFormate, convertMonthFromDate, fetchApi, formatMonthYear } from '../../utils/methods';
import { GetCompanyRewardsDocuments } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import { WellnessTickIcon } from '../../utils/icons';
import { Divider } from '../../components/UserDashboard/styles';
import {GetCompanyRewardPoints} from '../../redux/constants/apiConstants';
import SkeletonLoder from '../../components/common/skeletonLoder';



class CompanyRewardDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstIndex: 0,
      secondIndex: 0,
      showPDFModal: false,
      pdfBase64: '',
      isDownload: false,
      onHover: -1,
      rewardDetails:{},
      loading:true,
    }
  }


  componentDidMount() {
    this.FetchCompanyRewardDetails();
  }

  componentDidUpdate(prevProps) {
    if(prevProps.companyRewardsDocuments !== this.props.companyRewardsDocuments) {
      if(!isEmpty(this.props.companyRewardsDocuments)) {
        this.setState({
          pdfBase64: this.props.companyRewardsDocuments.reward_document
        });
        if(this.state.isDownload) {
          this.downloadFile(this.props.companyRewardsDocuments.reward_document);
        } else {
          this.setState({showPDFModal: true});
        }
      }
    }
  }

  onOpenPdf(documentId) {
    this.setState({
      isDownload : false
    });
    const { getCompanyRewardsDocuments } = this.props;
    getCompanyRewardsDocuments(documentId);
  }

  onFetchDocumentById(documentId) {
    const { getCompanyRewardsDocuments } = this.props;
    getCompanyRewardsDocuments(documentId);
    this.setState({
      isDownload : true
    });
    // const pdfBase64 = 'data:application/pdf;base64,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';
  }

  // To Fetch All Rewards Documents for a selected company
  downloadRewardsDocument = async (documentId, title) => {

    try{
      const res = await fetchApi(`${GetCompanyRewardsDocuments}/${documentId}`, "GET");
      if(res?.data?.message){
        toast.error(res?.data?.message);
      }else{
        if(res?.data?.reward_document){
          this.downloadFile(res?.data?.reward_document, title);
        }else{
          toast.error("No document found to download");
        }
        
      }

    }catch(err){
      toast.error(err);
    }
  }


  FetchCompanyRewardDetails = async () => {
    try {
      const { userId } = this.props;
      const url = `${GetCompanyRewardPoints}?user_id=${userId}`;
  
      const res = await fetchApi(url, "GET");

      window.console.log("res",res)
      if (res.status === "success") {
        this.setState({rewardDetails: res.data,loading:false});
        // Handle the successful response here, if needed
      } else {
        toast.error(res.error);
        this.setState({loading:false});
      }
    } catch (error) {
      window.console.error(error);
      this.setState({loading:false});
    }
  };



  downloadFile = (ImageBase64, document_title) => {
    const downloadLink = document.createElement("a");
    downloadLink.download = document_title;
    downloadLink.target = '_blank';
    downloadLink.href = ImageBase64;
    downloadLink.click();
  }

  removePDF = () => {
    this.setState({
      showPDFModal: false,
      pdfBase64: '',
    })
  };

  closePopup = () =>  {
    this.setState({
      showPDFModal: false
    })
  }


  onEnterMouse = (id) => {
    this.setState({
      onHover: id
    })
  };

  onLeaveMouse = () => {
    this.setState({
      onHover: -1
    })
  };

  render() {
    const { companyRewards, t } = this.props;
    const {onHover,rewardDetails,loading} = this.state;
    const lang = localStorage.getItem("lang");
    if (loading) {
      return (
        <SkeletonLoder width={"100%"} height={"400px"} style={{margin:"25px 0px"}}/>
      );
    }

    return (
      <div>
        <Layout margin={"20px 0px 0px 0px"}>
          <RewardTablesContainer>
            {(!rewardDetails || !rewardDetails?.levels || rewardDetails.levels.length === 0) ? (
              null
            ) : (
              <BodyTableV1
                isHeight="74px"
                isPaddingHeader="16px 16px 0px 16px"
                isMargin="0px 16px 20px 16px"
                isPadding="15px 15px 15px 16px"
                isBorder="0.75px solid #DCDCDC"
                borderRadius="12px"
                noBoxShadow="none"
                // key={index} 
                bgcolorOne={  '#FEFEFE' } 
                height={'322px'}
                // height={index === 0 ? '322px' : companyRewardData.reward_name === 'My Company Rewards' ? '322px' : companyRewardData.reward_name === 'Medical Premium Reduction' ? '236px' :'322px'}
              >
                <div className={'tableHeader'}>
                  <div className={'headerLeft'}>
                    <span className="headerText">{t(rewardDetails.program_title)}</span>
                  </div>
                  {/* <div className="prizeText">
                    {t("Total Prize value efef")}: {(rewardDetails?.prize_currency==='USD' ? "$" : '')(t(rewardDetails.total_prize_value))}
                  </div> */}
                  <div className="prizeText">
                    {t("Total Prize value")}:{" "}
                    {rewardDetails?.prize_currency === "USD" ? "$" : ""}
                    {t(rewardDetails?.total_prize_value)}
                  </div>
                </div>
                <Divider isOpacity={"40%"} isMargin={"20px 16px 20px 16px"}></Divider>
                {
                  rewardDetails?.levels?.map((rowData, rowIndex) => (
                    <div className={'tableContentContainer'} key={rowIndex}>
                      <div className='subContainer'>
                        <div className={'tableColumnHeader'}>
                          <div className={'tableColumn'}>
                            {t("Level")}
                          </div>
                          <div className={'tableColumn'}>
                            {t("My Points")}
                          </div>
                          <div className={'tableColumn'}>
                            {t("Point Goal")}
                          </div>
                          <div className={'tableColumn flex-basis-15'}>
                            {t("Prize")}
                          </div>
                          <div className={'tableColumn lastClass'}>
                            {t("Deadline")}
                          </div>
                          <div className={'tableColumn lastClass'}>
                            {t("Achieve On")}
                          </div>
                        </div>
                 
                        <div className={'tableRowContainer'} key={rowIndex}>
                          <div className={'tableRow'}>
                            {rowData.level_name ? t(rowData.level_name) : '-'}
                          </div>
                          <div className={'tableRow'}>
                            {rowData.my_points ? t(commaSeperator(rowData.my_points)) : '-'}
                          </div>
                          <div className={'tableRow'}>
                            {rowData.point_goal ? t(commaSeperator(rowData.point_goal)) : '-'}
                          </div>
                          <div className={'tableRow flex-basis-15 prize-cell'}  title={(rowData?.prize_description || "")?.replace(/(\d),(?=\d{3})/g, "$1")}>
                            {rowData?.prize_description ? t((rowData?.prize_description || "")?.replace(/(\d),(?=\d{3})/g, "$1")) : '-'}
                          </div>
                          <div className={'tableRow lastRow'}>
                            {rowData.deadline ? ( (lang !== "fr") ? (convertMonthFormate(rowData.deadline, this.props)) : (convertMonthFromDate(rowData.deadline, this.props).replace(/,/g,""))) : '-'}
                          </div>
                          <div className={'tableRow lastRow'}>
                            {rowData.achieved_at ? formatMonthYear(rowData.achieved_at, this.props) : '-'}
                          </div>
                        </div>
                      </div>
                      <div className='background_container'>
                        <TickMark  bgColor={rowData.achieved_at !== null ? '#75B084' : '#DCDCDC'} style={{height:'80px'}}>
                          <div className="icon">{WellnessTickIcon()}</div>
                          {/* <Circle>
                              <Tick  checked={rowData.check_status === 1 ? 'rgba(159, 201, 137, 1)' : 'rgba(156, 156, 156, 1)'}/>
                            </Circle> */}
                        </TickMark>
                      </div>
                    </div>
                  ))
                }
              </BodyTableV1>
            )}
          </RewardTablesContainer>

          {companyRewards.reward_documents && companyRewards.reward_documents.length ? 
            <DocumentsContainer>
              <div className='titleName'>{t("Documents")}</div>
              <div className='main_document'>
                {
                  companyRewards.reward_documents && companyRewards.reward_documents.length ?
                    companyRewards.reward_documents.map((doc, docIndex) => (
                      <MainImage key={docIndex} marginRight={docIndex === 0 ? '0' : docIndex === 1 ? '25px' : '25px'}>
                        <ImageTag   onMouseEnter={() => this.onEnterMouse(doc.id)} onMouseLeave={() => this.onLeaveMouse()}>
                          <img src={`${ImageUrl}/${doc.document_image}`} alt=""/>
                          <diV className='image_background'>
                            {onHover === doc.id &&
                   <div className='educateImageBackground'>
                     <div className="getStarted"  onClick={() => this.downloadRewardsDocument(doc.id, doc.title)}>{t("Download File")}</div>
                   </div>
                            }
                          </diV>
                        </ImageTag>
                      </MainImage>))
                    :  null} 
              </div>

              <ReactPDF
                showModal={this.state.showPDFModal}
                closeModal={this.closePopup}
                pdfBase64={this.state.pdfBase64}
                reward={1}
                buttonText={'Close'}
                showCrossMarker={true}
                removePDF={this.removePDF}
              />
            </DocumentsContainer>
            : null}
        </Layout>
      </div>
    )
  }


}

CompanyRewardDetails.propTypes = {
  reward: PropTypes.object,
  getCompanyRewards: PropTypes.func,
  getCompanyRewardsDocuments: PropTypes.func,
  companyRewards: PropTypes.array,
  companyRewardsDocuments: PropTypes.array,
  clearCompanyRewardsDocuments: PropTypes.func,
  t: PropTypes.func,
  userId: PropTypes.number,
};

const mapStateToProps = (state) => ({
  userId: state.profileData.userId,
  companyRewards: state.wellnessDashboard.companyRewards,
  companyRewardsDocuments: state.wellnessDashboard.companyRewardsDocuments,
});

const mapDispatchToProps = (dispatch) => ({
  getCompanyRewards: () => dispatch(getCompanyRewards()),
  getCompanyRewardsDocuments: (id) => dispatch(getCompanyRewardsDocuments(id)),
  clearCompanyRewardsDocuments: () => dispatch(clearCompanyRewardsDocuments())
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CompanyRewardDetails));
